import { render, staticRenderFns } from "./NotesPage.vue?vue&type=template&id=a0a30fc2&scoped=true"
import script from "./NotesPage.vue?vue&type=script&lang=js"
export * from "./NotesPage.vue?vue&type=script&lang=js"
import style0 from "./NotesPage.vue?vue&type=style&index=0&id=a0a30fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a30fc2",
  null
  
)

export default component.exports